import styled from 'styled-components'

export const RankmiTableWrapper = styled.div`
  .ant-table-wrapper {
    margin-top: -9px;
  }
  .ant-table-wrapper + div {
    margin-bottom: -2px !important;
  }
`
